import { createEffect, createSignal } from "solid-js"
import isFloatArraySame from "../signal/equals/isFloatArraySame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { createSharedTileGraphNodeCollectionMemo } from "./createSharedTileGraphNodeCollectionMemo"

export const useTerrainBaseWaterElevationListMemo = createSharedCachedFactory((engine) => {
  const getTileGraphNodesList = createSharedTileGraphNodeCollectionMemo(engine)

  const [getBaseElevationList, setBaseElevationList] = createSignal<Float32Array>(new Float32Array(), {
    equals: isFloatArraySame,
  })

  createEffect(() => {
    const tpNodeList = getTileGraphNodesList()
    createEffect(() => {
      const list = new Float32Array(tpNodeList.length)
      for (let i = 0; i < tpNodeList.length; i++) {
        const tpNode = tpNodeList[i]
        list[i] = tpNode.water_e()
        // createEffect(() => {
        //   console.log('tpNode.elevation()', tpNode.elevation())
        // })
      }
      setBaseElevationList(list)
    })
  })

  // createEffect(() => {
  //   // console.log('TerrainBaseElevationList', memo())
  //   console.log('TerrainBaseElevationList', new Set([...memo()]))
  // })
  // createEffect(() => {
  //   const tpNodeList = getTileGraphNodesList()
  //   // console.log('TerrainBaseElevationList', memo())
  //   const list = [
  //     coord(4,4),
  //     coord(5,5),
  //     coord(4,5),
  //     coord(5,4),
  //   ]
  //   const list2 = tpNodeList.filter(tp => findByPosition(list, tp)).map(tp => tp.elevation())
  //   console.log('TerrainBaseElevationList2', list2)
  // })

  return getBaseElevationList
})